import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayContains',
    standalone: true
})
export class ArrayContainsPipe implements PipeTransform {

  transform(array: any[], value: unknown): boolean {
    return array.includes(value);
  }

}
